// Modules
import Navigation from 'modules/_navigation'
import ObjectFit from 'modules/_object-fit'
import Print from 'modules/_print'
import Accordion from 'modules/_accordion'
import ArticleArchive from 'modules/_article-archive'
import ArticleSliders from 'modules/_article-slider'
import GalleryWidgets from 'modules/_gallery-widgets'
import ListSection from 'modules/_list-section'
import SingleCarCoverSlider from 'modules/_single-car-cover-slider'
import Popup from 'modules/_popup'
import VideoModal from 'modules/_video-modal'
import { SmoothScroll } from 'modules/_smooth-scroll'
import CarModal from 'modules/_car-modal'
import CarArchive from './modules/_car-archive'
import ReviewSliders from './modules/_review-sliders'
import YoutubeBg from './modules/_youtube-bg'
import CoverSectionVideo from './modules/_cover-section-video'
import ReactRenderer from './react/_react-renderer'
import LoanCalculator from 'modules/react/loan-calculator/LoanCalculator'

// Register modules
Navigation()
ObjectFit()
Print()
Accordion()
new ArticleArchive()
ArticleSliders()
GalleryWidgets()
ListSection()
new SingleCarCoverSlider()
new Popup()
VideoModal()
SmoothScroll()
new CarModal()
CarArchive()
ReviewSliders()
YoutubeBg()
CoverSectionVideo()

window.addEventListener('load', () => {
  ReactRenderer.registerComponent('LoanCalculator', LoanCalculator)
  ReactRenderer.render()
})
